<template>
    <div class="container mx-auto px-4 py-8 max-w-3xl">
        <div class="flex items-center space-x-4">
            <button @click="goBack" class="flex items-center text-reader-text hover:text-primary">
                <i class="fa fa-arrow-left mr-2"></i>
                <span class="text-sm">返回</span>
            </button>
        </div>
        <h1 class="text-2xl font-bold mb-6">新建小说</h1>

        <form @submit.prevent="handleSubmit" class="bg-white rounded-lg shadow-md p-6">
            <!-- 小说封面 -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">小说封面</label>
                <div class="flex items-center space-x-4">
                    <!-- 封面预览 -->
                    <div class="relative">
                        <div v-if="!coverPreview" class="w-32 h-48 bg-gray-100 rounded-lg flex items-center justify-center">
                            <i class="fa fa-image text-3xl text-gray-400"></i>
                        </div>
                        <img v-else :src="coverPreview" class="w-32 h-48 object-cover rounded-lg border border-gray-200">

                        <!-- 删除按钮 -->
                        <button
                            v-if="coverPreview"
                            @click="removeCover"
                            class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                        >
                            <i class="fa fa-times text-xs"></i>
                        </button>
                    </div>

                    <!-- 上传控件 -->
                    <div>
                        <label class="cursor-pointer">
              <span class="block bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                <i class="fa fa-upload mr-2"></i>选择封面
              </span>
                            <input
                                type="file"
                                accept="image/*"
                                @change="handleCoverUpload"
                                class="hidden"
                            >
                        </label>
                        <p class="mt-2 text-xs text-gray-500">支持JPG/PNG格式，建议尺寸300×450px</p>
                    </div>
                </div>
            </div>

            <!-- 小说书名 -->
            <div class="mb-6">
                <label for="title" class="block text-sm font-medium text-gray-700 mb-1">小说书名</label>
                <input
                    type="text"
                    id="title"
                    v-model="form.title"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder="请输入小说书名"
                >
            </div>

            <!-- 小说简介 -->
            <div class="mb-6">
                <label for="description" class="block text-sm font-medium text-gray-700 mb-1">小说简介</label>
                <textarea
                    id="description"
                    v-model="form.description"
                    rows="4"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder="请输入小说简介"
                ></textarea>
            </div>

            <!-- 小说类型 -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">小说类型</label>
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
                    <label
                        v-for="type in novelTypes"
                        :key="type.value"
                        class="flex items-center space-x-2 cursor-pointer"
                    >
                        <input
                            type="radio"
                            v-model="form.type"
                            :value="type.value"
                            class="h-4 w-4 text-blue-600 focus:ring-blue-500"
                        >
                        <span>{{ type.label }}</span>
                    </label>
                </div>
            </div>

            <!-- 操作按钮 -->
            <div class="flex justify-end space-x-4 pt-4 border-t border-gray-200">
                <button
                    type="button"
                    @click="handleCancel"
                    class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                >
                    取消
                </button>
                <button
                    type="submit"
                    class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                    创建小说
                </button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios';
// const baseApiUrl = 'http://localhost:8081';
const baseApiUrl = ''; 
const router = useRouter()

// 表单数据
const form = ref({
    title: '',
    description: '',
    type: '玄幻',
    coverImage: ''
})

// 封面预览
const coverPreview = ref(null)
const coverFile = ref(null)

// 小说类型选项
const novelTypes = [
    { value: '玄幻', label: '玄幻' },
    { value: '都市', label: '都市' },
    { value: '历史', label: '历史' },
]

// 处理封面上传
const handleCoverUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    // 验证文件类型
    if (!file.type.match('image.*')) {
        alert('请选择图片文件')
        return
    }
    
    // 生成预览
    const reader = new FileReader()
    reader.onload = (e) => {
        coverPreview.value = e.target.result
    }
    reader.readAsDataURL(file)


    coverFile.value = file
}

// 删除封面
const removeCover = () => {
    coverPreview.value = null
    coverFile.value = null
}

// 模拟上传封面到服务器
const uploadCover = async (file) => {
  // 1. 创建 FormData 对象，将文件追加进去（字段名必须与后端 @RequestParam 一致）
  const formData = new FormData()
  formData.append('file', file)
  try {
    // 2. 发送 POST 请求
    const response = await axios.post(`${baseApiUrl}/api/novel/upload/cover`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data' // 告诉后端这是文件上传
      }
    })
    // 3. 根据后端返回的数据结构提取图片路径
    if (response.data.code === 0) {
      // 假设路径是 response.data.data
      const imagePath = response.data.data
      return imagePath // 返回给调用方，赋值给 form.value.coverPath
    } else {
      // 如果业务状态码不是0，抛出错误信息
      throw new Error(response.data.msg || '上传失败')
    }
  } catch (error) {
    // 4. 统一错误处理：可以在这里显示提示，并重新抛出错误以便上层捕获
    console.error('封面上传失败:', error)
    alert('封面上传失败，请重试')
    throw error // 让调用方知道上传失败
  }
}

// 表单提交
const handleSubmit = async () => {
    try {
        // 如果有封面文件，先上传
        if (coverFile.value) {
            form.value.coverImage = await uploadCover(coverFile.value)
        }
        console.log(form.value.coverImage);
        
        // 这里可以添加创建小说的API调用
        // 调用创建小说接口
        const response = await axios.post(`${baseApiUrl}/api/novel/upload/novel`, form.value, {
            headers: { 'Content-Type': 'application/json' }
        })
        if (response.data.code === 0) {
            alert('小说创建成功!')
            router.push('/novelManage')
        } else {
            alert(response.data.msg || '创建失败')
        }
        
    } catch (error) {
        console.error('创建失败:', error)
        alert('创建失败，请重试')
    }
}

// 取消创建
const handleCancel = () => {
    if (confirm('确定要放弃当前编辑的内容吗？')) {
        router.go(-1)
    }
}
const goBack = () => {
    router.go(-1)
}
</script>

<style scoped>
/* 自定义样式可以在这里添加 */
</style>